import {
  FormTokenChainState,
  FormTokenMetaRecord,
  FormTokenNode,
  MetaObject,
  PersistedFormTokenChainState,
  TokenId,
} from '../types/context';

// Puts meta back onto the persisted nodes: a string reference resolves to its
// IndexedDB record (missing record → meta degrades to undefined), a legacy
// inline object (old blob format / no-IDB fallback) is kept as-is
export const rehydrateFormTokensMeta = (
  records: FormTokenMetaRecord[],
  persistedFormTokens: PersistedFormTokenChainState
): FormTokenChainState => {
  const metaById: Record<TokenId, MetaObject> = {};
  records.forEach((record) => {
    metaById[record.id] = record.meta;
  });

  const nodes: Record<TokenId, FormTokenNode> = {};
  Object.values(persistedFormTokens.nodes).forEach((persistedNode) => {
    const { meta, ...nodeWithoutMeta } = persistedNode;
    const resolvedMeta = typeof meta === 'string' ? metaById[meta] : meta;
    nodes[persistedNode.id] = {
      ...nodeWithoutMeta,
      ...(resolvedMeta && { meta: resolvedMeta }),
    };
  });

  return { nodes, roots: persistedFormTokens.roots };
};
